export default __webpack_public_path__ + "static/media/rpl5.959df356.jpg";